import Component from "vue-class-component";
import Vue from "vue";

@Component
export default class DialogButton extends Vue {
  dialog: boolean = false;
  showBody: boolean = true;

  closeDialog(): void {
    this.dialog = false;
    this.clearBody();
  }

  clearBody(): void {
    this.showBody = false;
    this.$nextTick(() => {
      this.showBody = true;
    });
  }
}
